module.exports = __webpack_public_path__ + "static/media/home-bg-2026.4090239e.png";